var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 11.193"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hide_svg__cls-1{fill:#f34747}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide_svg__hide",
    transform: "translate(0 -49.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hide_svg__Group_16329",
    transform: "translate(0 49.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hide_svg__Group_16328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hide_svg__Path_31177",
    d: "M12.434 49.174a.514.514 0 00-.728 0L9.879 51a7 7 0 00-6.979.73 11.668 11.668 0 00-2.8 2.587.519.519 0 00.014.628 12.621 12.621 0 003.042 2.784l-1.607 1.608a.514.514 0 10.725.728L12.434 49.9a.517.517 0 000-.726zm-6.713 5.988a1.337 1.337 0 01-.111-.543 1.383 1.383 0 011.926-1.274zM8.3 52.589a2.409 2.409 0 00-3.328 3.329l-1.063 1.06a10.811 10.811 0 01-2.729-2.367 10.994 10.994 0 012.28-2.022 5.986 5.986 0 015.637-.8z",
    className: "hide_svg__cls-1",
    transform: "translate(0 -49.023)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hide_svg__Group_16331",
    transform: "translate(5.079 51.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hide_svg__Group_16330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hide_svg__Path_31178",
    d: "M189.469 155.822a13.9 13.9 0 00-2.2-2.2.521.521 0 10-.643.819 12.4 12.4 0 011.765 1.716 11.378 11.378 0 01-1.9 1.768 6.414 6.414 0 01-5.2 1.352.519.519 0 10-.213 1.015 6.46 6.46 0 001.349.141 6.86 6.86 0 002.05-.32 9.155 9.155 0 002.65-1.37 11.911 11.911 0 002.359-2.287.524.524 0 00-.017-.634z",
    className: "hide_svg__cls-1",
    transform: "translate(-180.663 -153.512)"
  }))))));
}

export default SvgHide;